import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App)

// 引入element ui依赖
import ElementPlus from "element-plus"
// 引入element 样式依赖
import "element-plus/dist/index.css"
// 引入element图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 导入路由
import router from "./router/index.js";

// 导入vuex
import store from "./store/index.js";

// 导入vue-axios模块
import VueAxios from 'vue-axios';
import axios from 'axios'; 
import "amfe-flexible"

app.use(ElementPlus);
 // 注册所有图标
 for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }

// 注册axios     
app.use(VueAxios, axios)

// 使用路由
app.use(router)

// 使用vuex
app.use(store)

app.mount('#app')
